var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12" },
        [
          _c("header-list", {
            attrs: {
              title: _vm.pageTitle,
              placeholderSearch: _vm.searchPlaceholder,
              routeAddName: `${_vm.moduleId}.${_vm.pageID}.create`,
              routeAddParams: { type: "resource" },
              canAdd: _vm.canAdd,
              addTitle: _vm.addLayer,
              icon: _vm.icon,
            },
            on: { search: _vm.onSearch },
            scopedSlots: _vm._u(
              [
                _vm.canAdd
                  ? {
                      key: "buttons-right",
                      fn: function () {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "btn btn-main btn-rounded btn-sm min-w-auto my-0 px-3 d-flex flex-row align-items-center justify-content-center flex-nowrap d-sm-inline",
                              attrs: {
                                to: {
                                  name: `${_vm.moduleId}.${_vm.pageID}.create`,
                                  params: { type: "group" },
                                },
                              },
                            },
                            [
                              _vm.icon != ""
                                ? _c("i", { class: _vm.icon })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t(_vm.addGroup))),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
            model: {
              value: _vm.query,
              callback: function ($$v) {
                _vm.query = $$v
              },
              expression: "query",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("recursive-list", {
                  attrs: {
                    list: _vm.list,
                    checkActions: _vm.checkActions,
                    moduleId: _vm.moduleId,
                    routeGroupEdit: `${_vm.moduleId}.${_vm.pageID}.show.group`,
                    routeItemEdit: `${_vm.moduleId}.${_vm.pageID}.show.item`,
                    canDetail: _vm.canDetail,
                    canEdit: _vm.canEdit,
                    canDelete: _vm.canDelete,
                    onRemove: _vm.onRemove,
                    deleteItem: _vm.deleteItem,
                    table: _vm.table,
                    showError: _vm.showError,
                    pageCode: _vm.pageID,
                    targetField: "layers",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }